module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_1024.d3fb9cbb.jpg";